import React, {useRef} from 'react';
import {Slide, toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from '../components/common/Header';
import {useLayout} from '../../hooks/useLayout';
import MobileHeader from '../components/common/MobileHeader';
import {CustomCloseButton} from '../components/Toast';
import {getCssVariable} from '../../util/style.utils';

interface BaseLayout {
    children: JSX.Element;
    hasPresActions?: boolean;
    inLobby?: boolean;
}

function BaseLayout(props: BaseLayout): JSX.Element {
    const {children, hasPresActions, inLobby = false} = props;

    const {mobileScreenSize, tabletScreenSize} = useLayout();
    const presContainer = useRef<HTMLDivElement>(null);

    return (
        <div className="l-base" ref={presContainer}>
            <div className="l-base__body">
                {mobileScreenSize || tabletScreenSize ? (
                    <MobileHeader hasPresActions={hasPresActions} inLobby={inLobby} tabletScreenSize={tabletScreenSize} />
                ) : (
                    <Header presContainerRef={presContainer} hasPresActions={hasPresActions} />
                )}

                <main>
                    {children}

                    <ToastContainer
                        position={toast.POSITION.BOTTOM_LEFT}
                        theme="light"
                        limit={6}
                        transition={Slide}
                        autoClose={5000}
                        hideProgressBar
                        newestOnTop={false}
                        closeOnClick={false}
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        style={{zIndex: getCssVariable('--z-index-toast')}}
                        closeButton={CustomCloseButton}
                    />
                </main>
            </div>
        </div>
    );
}

export default BaseLayout;
